import axios from "axios";
import Cookies from "universal-cookie";

function getToken() {
  const cookies = new Cookies();
  return cookies.get("token");
}

export const createAppointment = async ({
  tranId,
  techId,
  appointmentDate,  // YYYY-MM-DD
  appointmentTime,  // hh:mm A (e.g., "10:00 AM")
  notes,
  status = "scheduled",
}) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/appointment/create`,
    { tranId, techId, appointmentDate, appointmentTime, notes, status },
    { headers: { Authorization: `Bearer ${getToken()}` } }
  );
};


export const appointmentList = async (authtoken, month, page) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/appointment/list?page=${page}&perPage=9`,
    { month },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};

export const CalenderList = async (authtoken, month) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/appointment/calendar-list`,
    { month },
    {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    }
  );
};
